import React from 'react';
import { CheckIcon } from 'lucide-react';
import { heroSkills, mockupUrl, offerAnchor, trustChips } from '../data/content';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
import { Mark } from './ui/Section';
export function Hero() {
  return <section className="bg-ivory px-4 pb-14 pt-8 md:pb-16 md:pt-12" data-id="element-90" data-mp="4lqkazhutj53">
      <div className="mx-auto max-w-5xl text-center" data-id="element-91" data-mp="4njq6ckn7zc1">
        <p className="font-display text-xs font-extrabold uppercase tracking-[.3em] text-forest md:text-sm" data-id="element-92" data-mp="129qtzk94hnnc">
          Bright Digital Hub
        </p>
        <h1 className="mt-3 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-charcoal sm:text-5xl md:text-7xl" data-id="element-93" data-mp="x8b8jr319f4f">
          Complete <span className="text-forest" data-id="element-94" data-mp="nczqozwbvrsg">Stretching</span>{' '}
          <span className="text-gold-ink" data-id="element-95" data-mp="nekqp51ew2xp">System 2026</span>
        </h1>

        <OfferLink className="mx-auto my-6 max-w-[720px] md:my-8" label="See the Complete Stretching System 2026 offer" data-id="element-96" data-mp="3d2tnz8hi2ie0">
          <img src={mockupUrl} alt="Complete Stretching System 2026 bundle: 6 main volumes and 5 professional bonuses" className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-97" data-mp="3j7zgtn69y0is" />
        </OfferLink>

        <p className="mx-auto max-w-4xl font-display text-2xl font-black uppercase leading-tight text-charcoal md:text-4xl" data-id="element-98" data-mp="3e8mtz2fektg7">
          52 Weeks. 156 Ready-to-Teach Classes. <Mark data-id="element-99" data-mp="30g6l3kztm17d">Beginner to Advanced.</Mark>
        </p>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-charcoal/80 md:text-lg" data-id="element-100" data-mp="359javyg8ke1p">
          A complete year of ready-to-teach stretching programming with 52 weeks and 156 classes
          already organized from Beginner to Advanced —{' '}
          <b className="text-charcoal" data-id="element-101" data-mp="2hjf81tavgibr">so you don't have to build every class from scratch.</b>
        </p>

        <ul className="mt-6 flex flex-wrap justify-center gap-2" aria-label="Skills covered" data-id="element-102" data-mp="2lla70r5byjmd">
          {heroSkills.map(skill => <li key={skill} className="rounded-full bg-forest px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide text-ivory" data-id="element-103" data-mp="s2tbjfzvhzn3">
              {skill}
            </li>)}
        </ul>

        <div className="mt-8" data-id="element-104" data-mp="i9voqxnuloio">
          <Button href={offerAnchor} size="lg" subtext="6 volumes + 5 professional bonuses" data-id="element-105" data-mp="ddnenyoiclid">
            See the complete system
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2" data-id="element-106" data-mp="1ayjilhmnxm7u">
          {trustChips.map(chip => <li key={chip} className="inline-flex items-center gap-1.5 rounded-md border border-charcoal/15 bg-white px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-charcoal/80" data-id="element-107" data-mp="112pwb6j56ecv">
              <CheckIcon className="h-3.5 w-3.5 text-forest" aria-hidden="true" data-id="element-108" data-mp="3lu0454qihb1b" />
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}